import React, { useState } from 'react';
import styled from '@emotion/styled';

interface ColorPickerProps {
  colors: string[];
  selectedColor: string;
  onChange: (color: string) => void;
}

const HairColorPicker: React.FC<ColorPickerProps> = ({
  colors,
  selectedColor = '#8B5A2B',
  onChange,
}) => {
  const [customColor, setCustomColor] = useState(selectedColor);

  const handleColorChange = (color: string) => {
    setCustomColor(color);
    onChange(color);
  };

  return (
    <Container>
      {colors.map((color) => (
        <ColorButton
          key={color}
          color={color}
          isSelected={selectedColor === color}
          onClick={() => handleColorChange(color)}
        />
      ))}
      <Divider />

      <CustomColorWrapper color={selectedColor}>
        <CustomColorOption
          type='color'
          value={customColor}
          onChange={(e) => handleColorChange(e.target.value)}
          hasCustomColor={
            customColor !== selectedColor || selectedColor !== '#8B5A2B'
          }
        />
      </CustomColorWrapper>
    </Container>
  );
};

export default HairColorPicker;

const Container = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  padding: 8px 12px;
  overflow-x: auto;
  border-radius: 10px;
  background-color: #12131a;
  gap: 8px;

  &::-webkit-scrollbar {
    height: 4px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: ${({ theme }) =>
      theme.backgroundColor.bg_light_4}; /* 스크롤바 색상 */
  }

  &::-webkit-scrollbar-track {
    background-color: transparent; /* 스크롤바 트랙 색상 */
  }
`;

const ColorButton = styled.div<{ color: string; isSelected: boolean }>`
  flex: 0 0 auto;
  width: 20px;
  height: 20px;
  transition: 0.2s;
  border: ${({ isSelected }) =>
    isSelected ? '2px solid white' : '2px solid transparent'};
  border-radius: 50%;
  background-color: ${({ color }) => color};
  cursor: pointer;
`;

const Divider = styled.div`
  width: 2px;
  height: 24px;
  background-color: #555;
`;

const CustomColorWrapper = styled.div<{ color: string }>`
  flex: 0 0 auto;
  min-width: 20px;
  height: 20px;
  overflow: hidden;
  border-radius: 50%;
  background-color: ${({ color }) => color};
`;

const CustomColorOption = styled.input<{ hasCustomColor: boolean }>`
  width: 100%;
  height: 100%;
  padding: 0;
  border: none;
  cursor: pointer;

  &::-webkit-color-swatch-wrapper {
    padding: 0;
  }

  &::-webkit-color-swatch {
    border: none;
    border-radius: 50%;
    background: ${({ hasCustomColor }) =>
      hasCustomColor
        ? 'inherit'
        : `conic-gradient(
      from 90deg,
      #ff0000,
      #ff8000,
      #ffff00,
      #80ff00,
      #00ff00,
      #00ff80,
      #00ffff,
      #0080ff,
      #0000ff,
      #8000ff,
      #ff00ff,
      #ff0080,
      #ff0000
    )`};
  }

  &::-moz-color-swatch {
    border: none;
    border-radius: 50%;
    background: ${({ hasCustomColor }) =>
      hasCustomColor
        ? 'inherit'
        : `conic-gradient(
      from 90deg,
      #ff0000,
      #ff8000,
      #ffff00,
      #80ff00,
      #00ff00,
      #00ff80,
      #00ffff,
      #0080ff,
      #0000ff,
      #8000ff,
      #ff00ff,
      #ff0080,
      #ff0000
    )`};
  }
`;
